import React, { useState } from 'react';
import BadgeHeroSection from '../components/HeroSectionBadge';
import SEO from '../components/SEO';
import GetSEOData from '../data/SEO';
import AudienceNavigation from '../components/AudienceNavigation';
import SwitchSteps from '../components/SwitchSteps';
import InstallationSteps from '../components/InstallationSteps';
import { Link, graphql } from 'gatsby';
import LitImage from '../components/images/LitImage';
import LitStructuredText from '../components/generic/LitStructuredText';

const installation = ({ data }) => {
  const [installState, setInstallState] = useState(false);
  const installationData = data.allDatoCmsInstallationPageModel.nodes[0];
  let { title, description } = GetSEOData('/installation');

  return (
    <div className="bootstrap">
      <SEO
        title={installationData.seo.seoTitle ?? title}
        description={installationData.seo.seoDescription ?? description}
        metaTags={installationData.seoContent}
      />
      <div className="installation-container">
        <BadgeHeroSection
          heading={installationData.heroBanner.heading}
          heroImageDesktop={installationData.heroBanner.featureImage}
          heroImageMobile={installationData.heroBanner.featureImage}
          secondaryHeroImage={installationData.heroBanner.featureImage}
          mode={installationData.heroBanner.colour}
          layout={installationData.heroBanner.layout}
          hidePostcodeSearch
        />
        <div className="navigation-container">
          {installationData.quickNav.map(({ heading, icon, path }, index) => {
            return (
              <AudienceNavigation
                heading={heading}
                index={index}
                image={icon}
                path={path}
                installState={installState}
                setInstallState={setInstallState}
                isInstallationPage={true}
              />
            );
          })}
          <div className="link-container">
            <div className="navigation-icon">
              <LitImage image={data.navigationArea} alt="blue icon" />
            </div>
            <div className="navigation-header">
              <h2>Need help? Contact us</h2>
            </div>
            <div className="navigation-go-section">
              <Link to="#supportSection" className="navigation-link">
                Find out more
              </Link>
            </div>
          </div>
        </div>
        <SwitchSteps
          introText={installationData.section1Header}
          stepsData={installationData.section1Steps}
          mode={installationData.section1Colour}
        />
        <div className="installation-button-container">
          <button
            id={`${installationData.overgroundID}`}
            className="installation-overhead-button"
            onClick={() => {
              setInstallState(false);
            }}
          >
            <LitStructuredText
              data={installationData.overheadInstallsHeading}
              basic
            />
          </button>
          <button
            id={`${installationData.undergroundID}`}
            className="installation-underground-button"
            onClick={() => {
              setInstallState(true);
            }}
          >
            <LitStructuredText
              data={installationData.undergroundInstallsHeading}
            />
          </button>
        </div>
        <InstallationSteps
          data={
            installState
              ? installationData.undergroundInstallSection
              : installationData.overheadInstallSections
          }
          mode={installState ? 'Yellow' : 'Black'}
        />
        <div className="installation-next-container">
          <div className="installation-next-inner">
            <div className="installation-next-content">
              <div className="installation-next-header">
                <LitStructuredText
                  data={installationData.nextStepsSection.heading}
                />
              </div>
              <div className="installation-next-body">
                <LitStructuredText
                  data={installationData.nextStepsSection.copy}
                  basic
                />
              </div>
              <Link className="button" to={'/contact-us'}>
                Contact us
              </Link>
            </div>
            <div className="installation-next-image">
              <LitImage
                image={installationData.nextStepsSection.image}
                alt="rocket blasting out of box"
              />
            </div>
          </div>
        </div>
        <SwitchSteps
          id={installationData.installID}
          introText={installationData.installDayHeader}
          introTextSecondary={installationData.installDayCopy}
          stepsData={installationData.installDaySteps}
          mode={installationData.installDayColour}
          noSlider={true}
        />
        <SwitchSteps
          stepsData={installationData.supportSection}
          mode={installationData.supportColour}
          noSlider={true}
          id={'supportSection'}
        />
      </div>
    </div>
  );
};

export default installation;
export const query = graphql`
  query {
    allDatoCmsInstallationPageModel {
      nodes {
        seoContent {
          description
          title
          twitterCard
          image {
            gatsbyImageData
          }
        }
        undergroundID
        overgroundID
        installID
        heroBanner {
          colour
          layout
          heading {
            value
          }
          featureImage {
            gatsbyImageData
          }
        }
        seo {
          seoTitle
          seoDescription
        }
        quickNav {
          path
          icon {
            gatsbyImageData
          }
          heading {
            value
          }
        }
        section1Colour
        installDayColour
        supportColour
        section1Header {
          value
        }
        section1Steps {
          number
          copy {
            value
          }
          icon {
            gatsbyImageData
          }
        }
        overheadInstallsHeading {
          value
        }
        overheadInstallSections {
          heading {
            value
          }
          image {
            gatsbyImageData
          }
          copy {
            value
          }
          button
          buttonPath
          buttonText
        }
        undergroundInstallsHeading {
          value
        }
        undergroundInstallSection {
          heading {
            value
          }
          copy {
            value
          }
          image {
            gatsbyImageData
          }
          button
          buttonPath
          buttonText
        }
        nextStepsSection {
          heading {
            value
          }
          copy {
            value
          }
          image {
            gatsbyImageData
          }
        }
        installDayHeader {
          value
        }
        installDayCopy {
          value
        }
        installDaySteps {
          image {
            gatsbyImageData
          }
          copy {
            value
          }
        }
        supportSection {
          buttonPath
          buttonText
          image {
            gatsbyImageData
          }
          copy {
            value
          }
          heading {
            value
          }
        }
      }
    }
    navigationArea: file(
      relativePath: { eq: "audience-images/audienceNavigationArrow.png" }
    ) {
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`;
